import React, { useState } from "react";
import Label from "../Common/Label";
import RowContainer from "../Common/RowContainer";
import Container from "../Common/Container";
import editIcon from "../../assets/editIcon.svg";
import deleteIcon from "../../assets/deleteIcon.svg";
import copyIcon from "../../assets/copyIcon.svg";
import Switch from "../Common/Switch";
import styled from "styled-components";

interface TextField {
  id: number;
  name: string;
  theme: string;
  themeIsDeleted?: boolean;
  lessonLevel: string;
  point: string;
  created: string;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onCheckboxChange: (id: number) => void;
  isChecked: boolean;
  status: boolean;
  onStatusChange: (id: number) => void;
  onCopy: (id: number) => void;
}

const NewRowContainer = styled(RowContainer)`
  overflow: hidden;
`;

const NewLabel = styled(Label)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const TextField: React.FC<TextField> = ({
  id,
  name,
  theme,
  themeIsDeleted,
  lessonLevel,
  point,
  created,
  onEdit,
  onDelete,
  onCheckboxChange,
  isChecked,
  status,
  onStatusChange,
  onCopy,
}) => {
  const [isSwitchOn, setIsSwitchOn] = useState(status);

  const toggleSwitch = () => {
    const newStatus = !isSwitchOn;
    setIsSwitchOn(newStatus);
    onStatusChange(id);
  };

  const handleDelete = () => {
    onDelete(id);
  };

  return (
    <Container
      bgColor={isChecked ? "#f0ebff" : "#fff"}
      borderRadius="10px"
      height="50px"
      alignItems="center"
      display="flex"
      width="100%"
      className="user-data user-container-hover"
      style={{ outline: isChecked ? "2px solid #7542E4" : "none" }}
    >
      <RowContainer
        justifyContent="space-between"
        alignItem="center"
        borderRadius="12px"
        margin="10px"
      >
        {/* Checkbox */}
        <RowContainer flex="1.4" alignItem="center">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => onCheckboxChange(id)}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 16,
              height: 16,
              accentColor: "#7542E4",
              cursor: "pointer",
            }}
          />
        </RowContainer>
        <NewRowContainer flex="11" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {name}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="6" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {theme || "(Deleted Topic)"}
            {themeIsDeleted && (
              <span
                style={{
                  backgroundColor: "#fff3cd",
                  color: "#856404",
                  border: "1px solid #ffeeba",
                  fontSize: "11px",
                  padding: "2px 6px",
                  borderRadius: "4px",
                  marginLeft: "6px",
                  fontWeight: 600,
                }}
              >
                ⚠️ Deleted
              </span>
            )}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="3">
          <NewLabel fontSize="16px" fontWeight={400}>
            {lessonLevel}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="4">
          <NewLabel fontSize="16px" fontWeight={400}>
            {point}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="5">
          <NewLabel fontSize="16px" fontWeight={400}>
            {created}
          </NewLabel>
        </NewRowContainer>
        <RowContainer flex="2.5">
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <Switch isOn={isSwitchOn} onToggle={toggleSwitch} />
            <div
              style={{ cursor: "pointer" }}
              onClick={() => onCopy(id)}
              title="Clone text field"
            >
              <img
                src={copyIcon}
                className="user-scale"
                alt="Copy"
                style={{ WebkitUserSelect: "none", userSelect: "none" }}
              />
            </div>
            <div style={{ cursor: "pointer" }}>
              <img
                src={editIcon}
                onClick={() => onEdit(id)}
                className="user-scale"
                alt="Edit"
                style={{ WebkitUserSelect: "none", userSelect: "none" }}
              />
            </div>
            <div style={{ cursor: "pointer" }} onClick={handleDelete}>
              <img
                src={deleteIcon}
                className="user-scale"
                alt="Delete"
                style={{ WebkitUserSelect: "none", userSelect: "none" }}
              />
            </div>
          </div>
        </RowContainer>
      </RowContainer>
    </Container>
  );
};
export default TextField;
